import React from 'react';
import './css/style.css';
import MinesweeperContainer from './MinesweeperContainer';

export default function App() {
  return <MinesweeperContainer />;
}
